import { CreditCardIcon, MoneyIcon } from '@phosphor-icons/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'
import { Typography, TypographySizeKeys } from '@/components/ui/typography'
import { MarketShopOrderModel, PickUnion } from '@/models'

import * as S from './payment-method-alert.styled'

export type PaymentMethodAlertProps = {
  order: MarketShopOrderModel
  size?: PickUnion<TypographySizeKeys, 'text-medium' | 'heading-medium'>
}

export const PaymentMethodAlert = ({ order, size = 'text-medium' }: PaymentMethodAlertProps) => {
  const { t } = useTranslation(['market-shop-restaurant'])
  const isCash = order.paymentMethod === 'cash'
  const paymentMethodText = isCash
    ? t('market-shop-restaurant:paymentMethodAlert.cash')
    : t('market-shop-restaurant:paymentMethodAlert.card')

  return (
    <S.PaymentMethodAlert $isCash={isCash}>
      <Icon
        icon={isCash ? MoneyIcon : CreditCardIcon}
        size={size === 'text-medium' ? '2rem' : '2.4rem'}
      />
      <Typography as="span" size={size} weight="medium">
        {paymentMethodText}
      </Typography>
    </S.PaymentMethodAlert>
  )
}
